import React, { useEffect, useState } from 'react';
import * as R from 'ramda';

import { PartnersMainTableHeader } from './header';
import { PartnersMainTableRow } from './row';
import { PartnersFilters } from './filters';
import * as Loadings from '../../../../constants/loadings/backoffice/partners';
import Emptylustration from './../../../../assets/images/svg/057-contract-1.svg';
import { Link } from 'react-router-dom';


export const PartnersMainTable = ({ partners, setSelectedPartner, partnerState, pageSearch, setPageSearch, routerQuery }) => {
    const [filters, setFilters] = useState({
        order: {
            column: "id",
            asc: true
        },
        search: "",
    });

    const [displayableElements, setDisplayableElements] = useState(undefined);

    useEffect(() => {
        let temp = partners;
        // if (!R.isEmpty(filters.search)) {
        //     temp = temp.filter(d => d.id.search(filters.search) > -1 || d.name.search(filters.search) > -1);
        // }

        // setDisplayableElements(filters.order.asc ? R.sort(R.ascend(R.prop(filters.order.column)), temp) : R.sort(R.descend(R.prop(filters.order.column)), temp));

        setDisplayableElements(temp);

    }, [filters, partners]);




    return (
        <React.Fragment>
            <PartnersFilters filters={filters} setFilters={setFilters} pageSearch={pageSearch} setPageSearch={setPageSearch} routerQuery={routerQuery} />
            <div className="auto-view h-100 mb-auto">

                {
                    partnerState.isLoading.includes(Loadings.FETCHING_PARTNERS) ?
                        <div className="d-flex flex-column justify-content-center align-items-center h-100"><div className="spinner-border spinner-border-sm text-primary ml-1" role="status"><span className="sr-only">Loading...</span></div></div>
                        :
                        <React.Fragment>
                            <div className="container-fluid">
                                {R.isNil(partners) || R.isEmpty(displayableElements) ?
                                    <section className="block fs-3 text-center m-auto py-4">
                                        <img className="img-fluid img-contain container-paper mx-auto mb-4" src={Emptylustration} alt="Assist@" />
                                        <div className="block text-center container-thin mx-auto">
                                            <h1 className="font-weight-bolder ls-n2 lh-1">Aucune partenaire trouvée!</h1>
                                            <p className="o-80 mb-0">Malheureusement, nous ne parvenons pas à trouver le contenu que vous recherchez.</p>
                                        </div>
                                    </section>
                                    :
                                    <section className="block">
                                        <PartnersMainTableHeader filters={filters} setFilters={setFilters} pageSearch={pageSearch} setPageSearch={setPageSearch} partnerState={partnerState} routerQuery={routerQuery} />
                                        {
                                            R.isNil(displayableElements) ?
                                                null
                                                :
                                                displayableElements.map((partner) => {
                                                    return (
                                                        <PartnersMainTableRow key={partner.id} partner={partner} setSelectedPartner={setSelectedPartner} />
                                                    );
                                                })
                                        }
                                    </section>
                                }
                            </div>
                        </React.Fragment>
                }

            </div>
            <div className="container-fluid">
                <nav className="flex-row my-3 justify-content-center" aria-label="Page navigation">
                    {partnerState.currentPage > 1 ? <Link to={`/backoffice/partners?page=${1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-left-outline fs-2"></i></button>}
                    {partnerState.currentPage > 1 ? <Link to={`/backoffice/partners?page=${partnerState.currentPage - 1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-back-outline fs-2"></i></button>}

                    <span className="btn rounded-sm bg-dim px-2 py-1 mx-1 d-flex justify-content-center align-items-center fs-aux">{partnerState.currentPage} de {partnerState.totalPages}</span>

                    {partnerState.currentPage < partnerState.totalPages ? <Link to={`/backoffice/partners?page=${partnerState.currentPage + 1}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrow-ios-forward-outline fs-2"></i></button>}
                    {partnerState.currentPage < partnerState.totalPages ? <Link to={`/backoffice/partners?page=${partnerState.totalPages}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`} className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></Link> : <button disabled className="btn rounded-sm bg-white px-2 py-1 mx-1 d-flex justify-content-center align-items-center"><i className="eva lh-1 eva-arrowhead-right-outline fs-2"></i></button>}
                </nav>
            </div>
        </React.Fragment>
    );

};